import { createFileRoute } from '@tanstack/react-router';

import { DemandPartnerEditorPage } from '../features/demand/partners/components/DemandPartnerEditorPage/DemandPartnerEditorPage';

export const Route = createFileRoute('/demand/partners/create')({
  component: DemandPartnerCreateRoute,
});

function DemandPartnerCreateRoute() {
  return <DemandPartnerEditorPage />;
}
